module.exports = __webpack_public_path__ + "static/media/process-audio-static.b86e6fb0.png";